/** WhatsApp Manager's message-template page for the connected business account. */
export const WHATSAPP_MANAGER_TEMPLATES_URL = "https://business.facebook.com/wa/manage/message-templates/"
